module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/consulenzatelefonica/consulenzatelefonica.component.scss
// module id = ./src/app/consulenzatelefonica/consulenzatelefonica.component.scss
// module chunks = main